import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/* eslint-disable react/no-danger */
import { cloneElement, Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { hideModal as hideModalAction } from '../../../actions/ModalActions';
import { stopPropagation } from '../../../helpers/common';
import { propArrayStr, propBool, propChildren, propFunc, propOneOfType, propShape, propStr, } from '../../../helpers/custom-prop-types';
import { getModalValue } from '../../../helpers/modal';
class Modal extends Component {
    constructor() {
        super(...arguments);
        this.hideEvent = () => {
            const { enabledBackGroundClick, isLoading, onBackClick } = this.props;
            if (isLoading || !enabledBackGroundClick) {
                return;
            }
            this.hideModal();
            if (onBackClick) {
                onBackClick();
            }
        };
        this.hideModal = () => {
            const { hideModal, modalType } = this.props;
            hideModal(modalType);
        };
    }
    componentDidUpdate(prevProps) {
        const isShowPrev = !!prevProps.isShow;
        const { isShow, modalValue, onShowModal } = this.props;
        if (onShowModal && !isShowPrev && isShow) {
            onShowModal(modalValue);
        }
    }
    componentWillUnmount() {
        this.hideModal();
    }
    render() {
        const { children, hideRemove, isLoading, isSetInnerHTML, isSetInnerHTMLHideRemove, isShow, isWide, modalClass, modalClassName, propHide, showCloseButton, } = this.props;
        const innerClassName = `modal-inner ${modalClass} ${isWide ? 'wide' : ''}`;
        const renderFunc = () => {
            if (isSetInnerHTML) {
                return (_jsx("div", { className: innerClassName, dangerouslySetInnerHTML: {
                        __html: !isSetInnerHTMLHideRemove || isShow ? children : null,
                    }, onClick: stopPropagation, role: 'presentation' }));
            }
            if (hideRemove && !isShow) {
                return null;
            }
            return (_jsx("div", Object.assign({ className: innerClassName, onClick: stopPropagation, role: 'presentation' }, { children: propHide
                    ? cloneElement(children, { hideModal: this.hideModal })
                    : children })));
        };
        return (_jsxs("div", Object.assign({ className: `modal ${modalClassName} ${isShow ? 'is-active' : ''}`, onClick: this.hideEvent, role: 'presentation' }, { children: [!isLoading && showCloseButton && (_jsx("div", Object.assign({ className: 'modalClose close' }, { children: _jsx("i", Object.assign({ className: 'material-icons md-48' }, { children: "clear" })) }))), _jsx("div", Object.assign({ className: 'modal-container' }, { children: renderFunc() }))] })));
    }
}
Modal.propTypes = {
    children: propChildren().isRequired,
    enabledBackGroundClick: propBool(),
    hideModal: propFunc().isRequired,
    hideRemove: propBool(),
    isLoading: propBool(),
    isSetInnerHTML: propBool(),
    isSetInnerHTMLHideRemove: propBool(),
    isShow: propBool().isRequired,
    isWide: propBool(),
    modalClass: propStr(),
    modalClassName: propStr(),
    modalType: propStr().isRequired,
    modalValue: propOneOfType([propShape(), propStr(), propArrayStr()])
        .isRequired,
    onBackClick: propFunc(),
    onShowModal: propFunc(),
    propHide: propBool(),
    showCloseButton: propBool(),
};
Modal.defaultProps = {
    enabledBackGroundClick: true,
    hideRemove: false,
    isLoading: false,
    isSetInnerHTML: false,
    isSetInnerHTMLHideRemove: true,
    isWide: false,
    modalClass: '',
    modalClassName: '',
    onBackClick: null,
    onShowModal: null,
    propHide: true,
    showCloseButton: true,
};
const mapStateToProps = ({ modal }, { modalType }) => {
    const modalValue = getModalValue(modal, modalType);
    return {
        isShow: !!modalValue.show,
        modalValue: modalValue.item || {},
    };
};
const mapDispatchToProps = (dispatch) => ({
    hideModal: (modalType) => dispatch(hideModalAction(modalType)),
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(Modal);
